export interface ContentHeaderThemeInterface {
  backgroundColor: string
  textColor: string
}

export const theme: ContentHeaderThemeInterface = {
  backgroundColor: '#f2f2f2',
  textColor: '#333333',
}
